import React from 'react';
import { Grid } from '@material-ui/core';
import { Text } from 'library';
import { JobModel, PostAttachmentProps } from '../NewsfeedModels';
import JobCard from '../jobCard/JobCard';
import { track } from 'shared/Tracking';
import { useHistory } from 'react-router-dom';
import { useUserContext } from 'UserContext';

const descriptionLengthLimit = 100;

function JobPost({ content }: PostAttachmentProps<JobModel>) {
    const history = useHistory();
    const { user } = useUserContext();

    function goToJob() {
        track('View Job details', { job: content, type: 'Post Click' });
        if (content.family.user.id === user?.id) {
            history.push('/jobs', {
                ongoing_id: content.ongoing_id,
            });
        }
    }

    const truncatedJobDescription =
        content.comments.length > descriptionLengthLimit
            ? `${content.comments.slice(0, descriptionLengthLimit)}...`
            : content.comments;

    return (
        <Grid item xs={12} onClick={goToJob}>
            <Text variant="body1">{truncatedJobDescription}</Text>
            <Grid container item xs={12} justify="center" style={{ paddingTop: 10 }}>
                <JobCard job={content} />
            </Grid>
        </Grid>
    );
}

export default JobPost;
